export default from './post-list';



// WEBPACK FOOTER //
// ./app/components/post-list/index.js